export const calcResizedUrl = (
  imagesEndpoint: string,
  uuid: string,
  paramString: string,
  canUseTransparentVersion = false
) => {
  return `${imagesEndpoint}/images/${calcResizedPath(uuid, paramString, canUseTransparentVersion)}`;
};

const calcResizedPath = (uuid: string, paramString: string, canUseTransparentVersion = false) => {
  return `resized/${paramString}/${uuid}.${canUseTransparentVersion ? 'webp' : 'jpg'}`;
};
